import gql from 'graphql-tag';
import {
  allOptionsFragment,
  allOptionsFragmentName,
  visualizationFragment,
  visualizationFragmentName,
  datasetFragment,
  datasetFragmentName,
  searchOptionsDatasetFragment,
  searchOptionsDatasetFragmentName,
  searchOptionsVizFragment,
  searchOptionsVizFragmentName,
  ADD_VISUALIZATION_QUERY_NAME,
  visualizationSummaryFragment,
} from './Fragments';

export const deleteVisualizationOp = 'deleteVisualization';
export const updateVisualizationOp = 'updateVisualization';
export const listDiscoveriesOp = 'listDiscoveries';

const Graphql = {
  VisualizationsByDataset: gql`
    query ${listDiscoveriesOp}($datasetId: String) {
      visualizations(datasetId: $datasetId) {
        ...${allOptionsFragmentName}
      }
    }
    ${allOptionsFragment}
  `,
  SearchOptions: gql`
    query ${listDiscoveriesOp} {
      visualizations {
        ...${searchOptionsVizFragmentName}
      }
      datasets {
        ...${searchOptionsDatasetFragmentName}
      }
    }
    ${searchOptionsVizFragment}
    ${searchOptionsDatasetFragment}
  `,
  AllVizOptionsQuery: gql`
    query ${listDiscoveriesOp} {
      visualizations {
        ...${allOptionsFragmentName}
      }
    }
    ${allOptionsFragment}
  `,
  DiscoveriesQuery: gql`
    query ${listDiscoveriesOp} {
      visualizations {
        ...${visualizationFragmentName}
      }
      datasets {
        ...${datasetFragmentName}
      }
    }
    ${visualizationSummaryFragment}
    ${datasetFragment}
  `,
  ExecuteQuery: gql`
    query executeQuery($query: DiscoverQuery!) {
      executeQuery(query: $query) {
        columnNames
        columnInfo {
          columnName
          attributeName
          columnType
          parentName
          aggregationName
        }
        results
      }
    }
  `,
  GetQuerySql: gql`
    query (
      $id: String!
      $measures: [QueryMeasureInput!]!
      $attributeNames: [String!]!
      $filters: [QueryFilterInput!]!
      $calcs: [QueryCalculationInput!]
      $subtotals: [QuerySubtotalInput!]
      $useFiscalCalendar: Boolean = false
    ) {
      getSql(
        query: {
          datasetId: $id
          attributeNames: $attributeNames
          measures: $measures
          filters: $filters
          calcs: $calcs
          sorts: []
          subtotals: $subtotals
          useFiscalCalendar: $useFiscalCalendar
        }
      )
    }
  `,
  CreateVisualizationMutation: gql`
    mutation ${ADD_VISUALIZATION_QUERY_NAME}($viz: VisualizationRequest!) {
      ${ADD_VISUALIZATION_QUERY_NAME}(visualization: $viz) {
        ...${visualizationFragmentName}
      }
    }
    ${visualizationFragment}
  `,
  DeleteVisualizationMutation: gql`
    mutation ${deleteVisualizationOp}($id: String!) {
      ${deleteVisualizationOp}(id: $id) {
        id
      }
    }
  `,
  UpdateVisualizationMutation: gql`
    mutation ${updateVisualizationOp}($viz: VisualizationRequest!) {
      ${updateVisualizationOp}(visualization: $viz) {
        ...${visualizationFragmentName}
      }
    }
    ${visualizationFragment}
  `,
  ComputeDateRangeQuery: gql`
    query ($request: DateRangeRequestInput!) {
      dateRange(dateRangeRequest: $request) {
        start
        end
      }
    }
  `,
};

export default Graphql;
